import React from 'react';

const SampleForm = () => {
    return (
        <div>
            <div className="mb-3">
                <span className="has-float-label">
                    <input className="form-control" id="name" type="text" placeholder="Name" />
                    <label htmlFor="name">Name</label>
                </span>
            </div>
            <div className="mb-3">
                <span className="has-float-label">
                    <input className="form-control" id="phone" type="email" placeholder="Email" />
                    <label htmlFor="email">Email</label>
                </span>
            </div>
            <div className="mb-3">
                <span className="has-float-label">
                    <input className="form-control" id="age" type="number" placeholder="Age" />
                    <label htmlFor="age">Age</label>
                </span>
            </div>
            <div className="mb-3">
                <span className="has-float-label">
                    <textarea className="form-control" id="comments" placeholder="Comments" />
                    <label htmlFor="comments">Comments</label>
                </span>
            </div>
        </div>
    );
};


export default SampleForm;
